import Table from "./Table";
import PageSelector from './PageSelector';

function Results() {

    return (
        <>
            <Table />
            <PageSelector />
        </>
    )
}

export default Results;